// Types
import type { IEvidence } from '@/types/evidence'
// Components
import { Box, Button, Dialog, TextField, Typography } from '@/CommonComponents'
// Hooks
import { useState } from 'react'
import { useTexts } from '@/contexts/LanguageContext'

interface IAddLinkDialogProps {
  isOpen: boolean
  onClose: () => void
  onChange: (link: IEvidence['externalLinks'][number]) => void
}

export default function AddLinkDialog({ isOpen, onClose, onChange }: IAddLinkDialogProps) {
  const { EVIDENCE_DRAWER } = useTexts()
  const blankLink = { label: '', url: '' }
  const [link, setLink] = useState<IEvidence['externalLinks'][number]>(blankLink)
  return (
    <Dialog
      open={isOpen}
      onClose={() => {
        onClose()
      }}
    >
      <Box sx={{ p: 3, display: 'flex', flexDirection: 'column', gap: 3 }}>
        <Typography variant="h6"> {EVIDENCE_DRAWER.ADD_LINK}</Typography>
        <TextField
          value={link.label}
          onChange={(event) => {
            setLink({ ...link, label: event.target.value })
          }}
          placeholder={EVIDENCE_DRAWER.ADD_LINK_LABEL}
        />
        <TextField
          value={link.url}
          onChange={(event) => {
            setLink({ ...link, url: event.target.value })
          }}
          placeholder={EVIDENCE_DRAWER.ADD_LINK_URL}
        />
        <Button
          label={EVIDENCE_DRAWER.ADD_LINK}
          variant="contained"
          disabled={!link.label || !link.url || link.label.trim() === '' || link.url.trim() === ''}
          icon="add-link"
          onClick={() => {
            onChange(link)
            setLink(blankLink)
          }}
        />
      </Box>
    </Dialog>
  )
}
